import { Injectable, InjectionToken, inject } from '@angular/core';
import { SplashScreen, SplashScreenPlugin } from '@capacitor/splash-screen';

// Il plugin passa dall'injector perche' il proxy Capacitor non si puo' sostituire nei test
export const SPLASH_SCREEN = new InjectionToken<SplashScreenPlugin>('SPLASH_SCREEN', {
  providedIn: 'root',
  factory: () => SplashScreen,
});

/**
 * Splash nativo mostrato all'avvio e a ogni ricarica della WebView (cambio lingua).
 * Il plugin Android in modalita' dialog (useDialog: true) ha un difetto: una hide() quando lo splash
 * non e' visibile lo lascia "in chiusura" per sempre, e alla ricarica successiva ogni hide() viene
 * ignorata (app ferma sullo splash). Quindi: niente autoHide e una sola hide() per ogni show().
 * Su iOS il plugin ignora una hide() arrivata mentre lo splash sta ancora comparendo: la hide() aspetta
 * che la show() sia finita.
 */
@Injectable({ providedIn: 'root' })
export class SplashService {
  private splash = inject(SPLASH_SCREEN);
  private mostrato: Promise<void> | null = null;

  mostra(): void {
    this.mostrato = this.splash.show({ autoHide: false }).catch(() => undefined);
  }

  nascondi(): void {
    const mostrato = this.mostrato;
    if (!mostrato) {
      return;
    }
    this.mostrato = null;
    mostrato.then(() => this.splash.hide());
  }
}
